<template>
  <div class="grid gap-6 xl:grid-cols-3">
    <BlogCard
      v-for="(blog, index) in data"
      :key="index"
      :blog="blog"
      class="lg:col-span-1"
    />
  </div>
</template>

<script lang="ts" setup>
const limit = ref(10)
const sort = ref({ date: -1, $numeric: true })
const { data } = await useAsyncData('collections-all-blogs',
  () => queryContent('/blog').limit(limit.value).sort(sort.value).find(),
  { transform: data => correctAssetRoutes(data),
    watch: [limit, sort],
  },
)

if (!data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Not Found',
  })
}
</script>

<style scoped>

</style>
